import { recordPath, recordRoute } from '@/shared/registry'

/** Where the content provider pages live. */
export const contentProvidersPath = '/catalog/content-providers'
export const createContentProviderPath = `${contentProvidersPath}/new`
export const contentProviderRoute = recordRoute('catalog', 'content-providers')
export const editContentProviderRoute = `${contentProviderRoute}/edit`

/** A content provider's details page. */
export function contentProviderPath(id: string): string {
  return recordPath('catalog', 'content-providers', id)
}

/** The base of Content Provider Details' slots (`detailsSlots`). */
export const contentProviderDetailsSlot = 'catalog.content-provider-details'

/** The API's content provider endpoints. */
export const contentProvidersApi = '/catalog/v1/content-providers'

export function contentProviderApi(id: string): string {
  return `${contentProvidersApi}/${encodeURIComponent(id)}`
}

/** The enabled providers a course of the organization may name. */
export function contentProviderChoicesApi(organizationId: string): string {
  return `${contentProvidersApi}/choices?organizationId=${encodeURIComponent(organizationId)}`
}

/** The enabled providers a saved course may name, for whoever may change that course. */
export function courseContentProviderChoicesApi(courseId: string): string {
  return `${contentProvidersApi}/choices?courseId=${encodeURIComponent(courseId)}`
}

/** What each content provider action needs. */
export const readContentProvidersPermission = 'catalog.content-providers.read'
export const writeContentProvidersPermission = 'catalog.content-providers.write'
export const deleteContentProvidersPermission = 'catalog.content-providers.delete'
